import axios from 'axios'

export default {
  namespaced: true,
  state: {
    workDocsSchemeTypeGrid: [],
    workDocsSchemeTypeAll: [],
    workDocsSchemeTypeShow: null,
    pageData: null,
  },
  mutations: {
    setWorkDocsSchemeTypeGrid(state, payload) {
      state.workDocsSchemeTypeGrid = payload
    },
    setWorkDocsSchemeTypeAll(state, payload) {
      state.workDocsSchemeTypeAll = payload
    },
    setWorkDocsSchemeTypeShow(state, payload) {
      state.workDocsSchemeTypeShow = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
  },
  getters: {
    workDocsSchemeTypeGrid: (state) => {
      return state.workDocsSchemeTypeGrid
    },
    workDocsSchemeTypeAll: (state) => {
      return state.workDocsSchemeTypeAll
    },
    workDocsSchemeTypeShow: (state) => {
      return state.workDocsSchemeTypeShow
    },
    pageData: (state) => {
      return state.pageData
    },
  },
  actions: {
    onWorkDocsSchemeTypeGrid({ commit, rootState }, { limit, page, sort, search }) {
      commit('setLoadingAnimation', true, { root: true })
      let url =
        rootState.apiDomain + '/api/admin/work/scheme-type/grid?limit=' + limit + '&page=' + page
      if (sort) {
        url = url + '&order[]=' + sort.param + ':' + sort.value
      } else {
        url = url + '&order[]=name:asc'
      }
      if (search) url = url + '&search=' + search
      return new Promise((resolve, reject) => {
        axios({
          url,
          limit: limit,
          page: page,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkDocsSchemeTypeGrid', resp.data.data)
            commit('setPageData', resp.data)
            commit('setLoadingAnimation', false, { root: true })
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimation', false, { root: true })
            reject(err)
          })
      })
    },
    onWorkDocsSchemeTypeAll({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain + '/api/admin/work/scheme-type/grid?limit=0' + '&order[]=name:asc',
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkDocsSchemeTypeAll', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkDocsSchemeTypeShow({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/scheme-type/' + id,
          id: id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkDocsSchemeTypeShow', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkDocsSchemeTypeCreate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/scheme-type',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkDocsSchemeTypeUpdate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/scheme-type',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkDocsSchemeTypeDelete({ rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/scheme-type/' + id,
          id: id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
